import React, {useImperativeHandle, useRef, useState} from 'react'
import {devServerTerminate} from '../../apis/devserver/devserver'
import WizModal from '../../components/modal/WizModal'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'

interface IProps {
    className?: string
}

const DeleteDevservernModal = ({className}: IProps, ref: any) => {
    const [branch, setbranch] = useState('')
    const modalRef = useRef<any>()

    useImperativeHandle(ref, () => ({
        show: branchName => {
            setbranch(branchName)
            modalRef.current.show()
        },
    }))

    const onClickDelete = async () => {
        await devServerTerminate(branch)
        modalRef.current.close()
        window.location.reload()
    }

    return (
        <>
            <WizModal title={'Remove League'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>해당 테스트 서버를 삭제하시겠습니까?</Text>
                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton
                        text={'Close server'}
                        type={'red'}
                        className={'flex-1'}
                        onClick={() => onClickDelete()}
                    />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(DeleteDevservernModal)
